module.exports = __webpack_public_path__ + "2464a42ee77c211190f4895593182959.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/People/CFO_Robert_Karlsson_web.jpg
// module id = 158
// module chunks = 0